import FlexBox, { FlexGrow } from "../../components/FlexBox";
import theme from "../../styles/theme";
import { HistoryType } from "../../types/ChangeHistory";
import { ChangeTypeIcons } from "./ChangeTypeIcons";

export const HistoryRow = (props: {
  data: HistoryType;
  // currentIndex: number;
  // index: number;
  // isSelected: boolean;
}) => {
  const { data} = props;
  const [date, timeWithSeconds] = data.change_timestamp.split(" ");
  const time = convertTo12HourFormat(timeWithSeconds?.slice(0, 5) || "00:00");

  function convertTo12HourFormat(time24: any) {
    // Split the time string into hours and minutes
    const [hours, minutes] = time24.split(":").map(Number);

    // Determine AM or PM
    const period = hours >= 12 ? "PM" : "AM";

    // Convert hour to 12-hour format
    const hours12 = hours % 12 || 12; // Use 12 instead of 0 for midnight/noon

    // Return formatted time
    return (
      `${hours12}:${minutes?.toString().padStart(2, "0")} ${period}` ||
      "00:00 AM"
    );
  }

  return (
    <FlexBox style={{ margin: "10px 20px 10px 0px" }}>
      <ChangeTypeIcons type={data.change_type} date={date} time={time} />
      <FlexGrow
        style={{
          background: theme.color.blue50,
          // border: isSelected ? "2px solid #89bcff" : "",
          padding: "15px 30px",
          borderRadius: 5,
          // marginLeft: "20px",
          display: window.innerWidth > 1200 ? "flex" : "",
          alignItems: "center",
          // boxShadow:isSelected ? "0px 2px 4px #80808042" : "",
          fontSize: "0.875rem",
        }}
      >
        <div
          style={{
            minWidth: window.innerWidth < 1290 ? 220 : 300,
            color: theme.color.blue900,
          }}
        >
          <div
            style={{
              width: window.innerWidth < 1290 ? 200 : 280,
              display: "flex",
              flexWrap: "wrap",
            }}
          >
            {data.user_name}
          </div>
          <div style={{ fontSize: "small" }}>{data.user_email}</div>
        </div>
        <div
          style={{
            width: window.innerWidth < 1290 ? 200 : 280,
            marginRight: 20,
            color: theme.color.blue800,
            fontWeight: "bold",
            // fontSize: 18
          }}
        >
          {data.change_type === "Create" ||
          data.change_type === "Update" ||
          data.change_type === "Delete"
            ? data.change_type + " " + data.change_object
            : data.change_type}
        </div>
        <FlexGrow>{data.description}</FlexGrow>
      </FlexGrow>
    </FlexBox>
  );
};
